export default "__VITE_ASSET__BWocgIYd__"